import { useGetPurchaseGrnQuery } from "shared/redux/endpoints/procurementGrn"
import { summarizeGoodsReceipt } from "./goodsReceipt"

// Compact received / partial / not-received badge for one PO. The numbers
// come from the goods-receipt API — nothing here is a fixed sample.
const GrStatusBadge = ({ purchaseId }) => {
  const { data, isLoading, isError, isFetching } = useGetPurchaseGrnQuery(purchaseId, { skip: !purchaseId })

  if (!purchaseId) return <span className="prc-gr prc-gr--muted">—</span>
  if (isLoading || (isFetching && data == null)) {
    return (
      <span className="prc-gr prc-gr--muted">
        <b>Loading…</b>
      </span>
    )
  }
  if (isError) {
    return (
      <span className="prc-gr prc-gr--muted" title="Goods receipt could not be loaded">
        <b>Unavailable</b>
      </span>
    )
  }
  const summary = summarizeGoodsReceipt(data)
  return (
    <span className={`prc-gr prc-gr--${summary.tone}`} title={`${summary.label} ${summary.detail}`}>
      <b>{summary.label}</b>
      <span>{summary.detail}</span>
    </span>
  )
}

export default GrStatusBadge
